<app-widget-facet-value-list [autoFocusSearch]="false" [checkboxMode]="true"></app-widget-facet-value-list>